import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, forwardRef } from '@angular/core';
import { CommonUtilty, ComponentOutputDO, AppMetadataHandler } from 'app';
import { MetadataService } from 'app/BaseFramework/core/http/metadata.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-search-and-link',
  templateUrl: './search-and-link.component.html',
  styleUrls: ['./search-and-link.component.scss']
})

export class SearchAndLinkComponent implements OnInit {

  _currentComponentName = "SearchAndLinkComponent";

  constructor(private viewContainerRef: ViewContainerRef,
    private commonUtility: CommonUtilty,
    public appMetadataHandler: AppMetadataHandler,
    public metadataService: MetadataService,
    public alertMsg: NzMessageService) { }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.searchAndLinkOutput);
    return c;
  }

  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { };
  }

  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { };
  }

  getCurrentComponentName(): string {
    return `${this._currentComponentName}`
  }

  @Input() searchTitle: string = "Search";
  @Input() searchAndLinkLabel: string = "Search & Link";
  //@Input() UIConfiguration: any;
  @Input() zeroStateMessageData = {
    title: "No Data",
    message: "No record to display.",
    icon: "question-circle"
  };

  @Output() searchAndLinkOutput = new EventEmitter<any>();


  ngOnInit(): void {
    this.getSearchCriteriaList();
    //this.renderTableWithConfiguration();
  }

  getSearchCriteriaList() {
    this.metadataService.getSearchCriteriaList(this.UIConfiguration['searchAPICriteria'])
      .subscribe(criteriaResp => {
        this.CRITERIA_LOOKUP = this.commonUtility.deepCopy(criteriaResp)
      })
  }

  fetchSearchResult($event) {
    if ($event && !$event.reset) {
      if ($event && $event.results) {
        this.searchedDataList = $event ? $event.results  : [];
        if (!(this.commonUtility.isArrayIterable(this.searchedDataList))) {
          this.alertMsg.error('No data found.');
        } else {
          this.filteredDataList = [...this.searchedDataList];
        }
      }
    }
    else {
      this.searchedDataList = [];
      this.filteredDataList = [...this.searchedDataList];
    }
  }

  rowSelectionStatusChanged(isChecked: boolean, guid: any) {
    if (this.UIConfiguration['isSingleSelection']) {
      this.selectedListOfData = [];
      this.setOfCheckedId.clear();
    }
    if (isChecked) {
      this.setOfCheckedId.add(guid);
      this.selectedListOfData.push(this.searchedDataList.filter(item => item.guid == guid)[0]);
    } else {
      this.setOfCheckedId.delete(guid)
      this.selectedListOfData = this.selectedListOfData.filter(item => item.guid != guid);
    }
  }

  // renderTableWithConfiguration(){

  // }

  CRITERIA_LOOKUP = [];
  searchedAndLinkedData: string;
  showSearchAndLinkModal: boolean = false;
  selectedListOfData: Array<any> = [];
  searchedDataList: Array<any> = [];
  //mapOfCheckedId: { [key: string]: boolean } = {};
  setOfCheckedId = new Set<number>();

  openSearchAndLinkModal() {
    this.showSearchAndLinkModal = true;
    this.resetSearchAndLinkTable();
  }

  handleSearchAndLinkCancel() {
    this.showSearchAndLinkModal = false;
  }

  addSearchAndLinkData() {
    let resultList = [];
    if (this.commonUtility.isArrayIterable(this.selectedListOfData)) {
      resultList = this.selectedListOfData.map(item => item[this.UIConfiguration['resultDisplayAttribute']]);
    }
    this.searchedAndLinkedData = resultList && resultList.length > 0 ? resultList.toString() : null;
    this.showSearchAndLinkModal = false;
    this.EmitComponentOutput(this.searchedAndLinkedData);
  }

  changeSearchedAndLinkedData() {
    this.openSearchAndLinkModal();
  }

  removeSearchedAndLinkedData() {
    this.resetSearchAndLinkTable();
    this.searchedAndLinkedData = null;
    this.EmitComponentOutput(this.searchedAndLinkedData);
  }

  resetSearchAndLinkTable() {
    this.searchedDataList = [];
    this.filteredDataList = [];
    this.selectedListOfData = [];
    this.setOfCheckedId.clear();
  }

  /** Search and Sort***/
  filteredDataList = [];

  sortName: string | null = null;
  sortValue: string | null = null;
  sort(sort: { key: string; value: string }): void {
    this.sortName = sort.key;
    this.sortValue = sort.value;

    if (this.sortName && this.sortValue) {
      let orderBy = this.sortValue === 'ascend' ? 'asc' : 'desc';
      this.filteredDataList = this.commonUtility.deepCopy(this.commonUtility.sortObject(this.sortName, this.filteredDataList, orderBy))
    } else {
      this.filteredDataList = this.commonUtility.deepCopy(this.searchedDataList);
    }
    console.log("sorted filteredDataList", JSON.stringify(this.filteredDataList));
  }

  searchValue: null;
  filterKey = null;

  filterMenuVisibilityChanged(event) {
    this.searchValue = null;
  }

  getConfigKey(key) {
    this.filterKey = key;
    console.log("config key", key);
  }

  searchConfiguration(value) {
    if (value) {
      this.filteredDataList = this.searchedDataList.filter(item => item[this.filterKey] ? item[this.filterKey].toLowerCase().includes(value.toLowerCase()) : [])
      this.searchValue = null;
    }
  }

  reset(): void {
    this.searchValue = null;
    this.filteredDataList = this.searchedDataList;
  }

  /**END: search and sort**/
  UIConfiguration = {
    "tableHeading": "Insured List",
    "searchAPICriteria": "searchProposal",
    "searchURL": "api/policy/searchProposal",
    "itemsPerPage": 100,
    "resultDisplayAttribute": "proposalNum",
    "isSingleSelection": true,
    "externalParams": [
      {}
    ],
    "searchTableHeaders": [
      {
        "header": "Insured First Name",
        "key": "firstName",
        "pipe": null,
        "sortFilter": true,
        "searchFilter": true,
        "isVisible": true,
        "width": "300px"
      },
      {
        "header": "Insured Last Name",
        "key": "lastName",
        "pipe": null,
        "sortFilter": true,
        "searchFilter": true,
        "isVisible": true
      },
      {
        "header": "Proposal Num",
        "key": "proposalNum",
        "pipe": null,
        "sortFilter": true,
        "searchFilter": true,
        "isVisible": true
      }
    ]
  };

}
